// Copyright 2017 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SoramaPortalCacheDb } from "libraries/IndexedDb/SoramaPortalCacheDb";
import { GenericIndexedDBRepository } from "repositories/GenericRepository";
import { MeasurementDevice } from "services/Hardware/Datatypes/MeasurementDevice";

@autoinject
export class MeasurementDeviceRepository extends GenericIndexedDBRepository<MeasurementDevice> {
    constructor(soramaPortalDb: SoramaPortalCacheDb) {
        super(soramaPortalDb, SoramaPortalCacheDb.MeasurementDeviceStoreName);
    }

    protected fromDatabase(databaseMeasurementDevice: MeasurementDevice): MeasurementDevice {
        return MeasurementDevice.copy(databaseMeasurementDevice);
    }
}
